
<template>
    
    <el-card shadow="never" class="box-card">
    <div slot="header" class="clearfix">
        <span>{{name}}</span>
    </div>
        <div class="text item paramContainer">
            <el-row :gutter="10">
                <el-col class="paramNameCol" :span="8">
                    CSS
                </el-col>
                <el-col :span="16">
                    <el-input
                        placeholder="Please input URI"
                        v-model="model.params.selector"
                        clearable>
                    </el-input>        
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    xPATH
                </el-col>
                <el-col :span="16">
                    <el-input
                        placeholder="Input region (text)"
                        v-model="model.params.xpath"
                        clearable>
                    </el-input> 
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Required
                </el-col>
                <el-col :span="16">
                    <el-checkbox class="clickCheckbox" v-model="model.params.required"></el-checkbox>        
                </el-col>
            </el-row>
             <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Delay before check
                </el-col>
                <el-col :span="16">
                    <el-input-number size="mini" v-model="model.params.delay_before_check"></el-input-number>        
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Max wait time
                </el-col>
                <el-col :span="16">
                    <el-input-number size="mini" v-model="model.params.max_wait_time"></el-input-number>        
                </el-col>
            </el-row>
            <el-row>
                <div class="tip">
                    Check if element is there
                </div>
            </el-row>
        </div>
    </el-card>    
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
    name: 'ElementPresence',
    props: {
        model: {
            type: Object,
            default: () => {}
        },
    },
    data () {
        return {
            name:'Element Presence',
            
        }
    },

    methods: {
    },
    computed: {
        ...mapState('bot', {
        bot: 'bot',
        project: 'project',
        error: 'error',
        loading: 'loading',
        }),
    },
    
}
</script>

<style lang="scss" scoped>
    .clickCheckbox {
        margin-top: 10px;
    }
</style>
